import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {DeviceFormComponent} from './device-form.component';
import {DeviceOverviewComponent} from './device-overview.component';
import {DeviceService} from './device.service';

@NgModule({
  declarations: [
    DeviceOverviewComponent,
    DeviceFormComponent
  ],
  exports: [
    DeviceOverviewComponent,
    DeviceFormComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    DeviceService
  ]
})
export class DeviceModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/device/device.module.ts